<a routerLink="/on-demand/products/{{ product.getSlug() }}" class="product-info" [ngClass]="{'link--disabled': isLinkDisabled}">
    <app-image-container [image]="imageUrl" type="small-product"></app-image-container>
    <div class="product-info--label color--primary-grey ml-2">
        <span [innerHTML]="product.label | safeContent" class="d-block font-5 font-weight-bold text-hidden-ellipsis"></span>
        <div class="d-block font-6">
            <app-product-item-number [itemNumber]="product.firstSku.getDisplaySkuID()"
                                     [supplierId]="product.firstSku.supplierId"></app-product-item-number>

        </div>
    </div>
    <div>
        <app-product-price [price]="price"
                           [priceRange]="product.hasVariations ? product.priceVariations : null"
                           [originalPrice]="product.getOriginalPrice()"
                           [discount]="product.discount ? product.discount : 0"
                           [currency]="product.currency"
                           [solelySymbol]="true"
                           color="color--primary-grey"
                           fontSize="font-5"
                           orientation="vertical"></app-product-price>
        <span *ngIf="product.skus[0].packageQuantity == 1" class="font-6 color--primary-grey">EA</span>
        <span *ngIf="product.skus[0].packageQuantity > 1"  class="font-6 color--primary-grey">{{ product.skus[0].attr_pkg_qty }}/PK</span>
    </div>
</a>
